// extracted by mini-css-extract-plugin
export default {"main":"ChatBox_main__DEYrn","loadcontainer":"ChatBox_loadcontainer__DkZCU","container":"ChatBox_container__-Mju8","header":"ChatBox_header__SDM9q","link":"ChatBox_link__ohhOC"};